import { render } from "./PreviewArticle.vue?vue&type=template&id=06250654&scoped=true"
import script from "./PreviewArticle.vue?vue&type=script&lang=js"
export * from "./PreviewArticle.vue?vue&type=script&lang=js"

import "./PreviewArticle.vue?vue&type=style&index=0&id=06250654&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06250654"]])

export default __exports__